import { useTranslation } from 'react-i18next';

export function useAppBranding() {
  const { i18n } = useTranslation();
  const isHe = i18n.language === 'he';

  const companyName = 'Vidnight';
  const appName = 'Vidnight';
  const loginSubtitle = isHe
    ? 'סטודיו הפקת וידאו מקצועי'
    : 'Professional Video Production Studio';

  // Split appName into two lines for the slogo
  const spaceIdx = appName.indexOf(' ');
  const slogoLine1 = spaceIdx > 0 ? appName.slice(0, spaceIdx) : appName;
  const slogoLine2 = spaceIdx > 0 ? appName.slice(spaceIdx + 1) : '';

  return {
    companyName,
    appName,
    loginSubtitle,
    slogoLine1,
    slogoLine2,
    fullName: `${companyName} ${appName}`,
  };
}
